import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackQuickOrderTemplateDownloadedParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/quickOrder/trackQuickOrderTemplateDownloaded";

const useTrackQuickOrderTemplateDownloaded = (
    parameters: TrackQuickOrderTemplateDownloadedParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.quickOrderTemplateDownloaded, parameters, options);
};

export default useTrackQuickOrderTemplateDownloaded;
